export default __webpack_public_path__ + "static/119-4a1fc52f419a0e31ed96902403121da5.gif";